import { render, staticRenderFns } from "./sitemap.vue?vue&type=template&id=4f7ba062&"
import script from "./sitemap.vue?vue&type=script&lang=js&"
export * from "./sitemap.vue?vue&type=script&lang=js&"
import style0 from "./sitemap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports